// Mock data for the public landing page interactive sections.
// Used by the live-mockup journal entry card to surface AI-style reflection
// questions without calling the real backend.

export const journalQuestionPool = [
  "What is one small thing today that you do not want to forget?",
  "What surprised you about your reaction to something this week?",
  "If you had to name what is taking up the most space in your head right now, what would it be?",
  "What is one thing you are quietly proud of from the last few days?",
  "Where in your day did you feel most like yourself?",
  "What did you avoid today, and what was underneath that?",
  "Which moment today felt out of step with the kind of week you wanted?",
  "What did your body tell you that your mind tried to ignore?",
];

export const journalQuestionPoolDe = [
  "Was ist eine Kleinigkeit von heute, die du nicht vergessen willst?",
  "Was hat dich diese Woche an deiner eigenen Reaktion überrascht?",
  "Wenn du benennen müsstest, was gerade den meisten Platz in deinem Kopf einnimmt - was wäre es?",
  "Worauf bist du in den letzten Tagen im Stillen stolz?",
  "In welchem Moment heute hast du dich am meisten wie du selbst gefühlt?",
  "Was hast du heute vermieden - und was steckt dahinter?",
  "Welcher Moment heute passte nicht zu der Woche, die du eigentlich wolltest?",
  "Was hat dir dein Körper gesagt, das dein Kopf zu ignorieren versucht hat?",
];

export const journalDemoEntryEn = {
  title: "Long run by the river",
  content:
    "10k along the river path. Slept nine hours and felt it the whole run. Phone stayed in my pocket. Brain quiet for the first time this week.",
};

export const journalDemoEntryDe = {
  title: "Langer Lauf am Fluss",
  content:
    "10 km am Fluss entlang. Neun Stunden geschlafen und das den ganzen Lauf gespürt. Handy blieb in der Tasche. Zum ersten Mal diese Woche war der Kopf ruhig.",
};
